import dwhExport from '~/dwhExport'
import {
    Button,
    ButtonGroup,
    CheckboxWithLabel, DialogBody,
    DialogContainer,
    DialogFooter,
    DialogHeader,
    Message,
    Processing,
    Radio,
    Textarea
} from '@wg/wows-react-uikit'
import { LANGUAGES } from '../../../constants'
import { t } from 'helpers/localization'
import filter from 'lodash/filter'
import get from 'lodash/get'
import unescape from "lodash/unescape";
import React, { PureComponent } from 'react'
import { clanData, ClanRecommendationsSettings, PURPOSES } from '../../../Actions/ActionRecommendations'
import { getLanguagesMap } from '../helpers'
import Terms from '../Terms/Terms'
import styles from './ClanSettingsDialog.scss'


export type ClanSettingsDialog_Props = {
    isFetching: Boolean,
    descriptionError: String,
    clanSettings: ClanRecommendationsSettings,
    clanData: clanData,
    hideDialog: () => void,
    updateSettings: (clanSettings: ClanRecommendationsSettings) => void,
    sendDescription: (description: String) => void,
    loadSettings: () => void,
}

class ClanSettingsDialog extends PureComponent<ClanSettingsDialog_Props, any> {

    constructor(props) {
        super(props)

        this.state = {
            isLanguageNotSelected: false,

            languagesMap: getLanguagesMap(props.clanSettings.languages),
            purpose: props.clanSettings.purpose,
            isRecommendable: props.clanSettings.isRecommendable,
            isVoiceChatRequired: props.clanSettings.isVoiceChatRequired,

            clanData: props.clanData,
        }

        this.languageChanged = this.languageChanged.bind(this)
        this.updateSettings = this.updateSettings.bind(this)

        this.isRecommendableChanged = this.isRecommendableChanged.bind(this)
        this.isVoiceChatRequiredChanged = this.isVoiceChatRequiredChanged.bind(this)
        this.purposeChanged = this.purposeChanged.bind(this)

        this.descriptionChanged = this.descriptionChanged.bind(this)

        props.loadSettings()
    }

    UNSAFE_componentWillReceiveProps(nextProps: ClanSettingsDialog_Props, nextContext) {
        if (!nextProps.isFetching)
            this.setState({
                ...this.state,
                languagesMap: getLanguagesMap(nextProps.clanSettings.languages),
                purpose: nextProps.clanSettings.purpose,
                isRecommendable: nextProps.clanSettings.isRecommendable,
                isVoiceChatRequired: nextProps.clanSettings.isVoiceChatRequired,
                clanData: nextProps.clanData,
            })
    }

    getSelectedLanguages() {
        let languages = Object.entries(this.state.languagesMap)
        languages = Object.values(filter(languages, ([key, value]) => value === true))
        return languages.map(([languageCode, language]) => languageCode)
    }

    languageChanged(languageCode: String) {
        return () => {

            const languagesMap = {
                ...this.state.languagesMap,
                [languageCode]: !get(this.state.languagesMap, languageCode, false),
            }

            const isLanguageNotSelected = languagesMap ? filter(Object.values(languagesMap)).length === 0 : false

            this.setState({
                ...this.state,
                languagesMap,
                isLanguageNotSelected,
            })
        }
    }

    isRecommendableChanged(isRecommendable: Boolean) {
        this.setState({ ...this.state, isRecommendable })
    }

    isVoiceChatRequiredChanged(isVoiceChatRequired: Boolean) {
        this.setState({ ...this.state, isVoiceChatRequired })
    }

    purposeChanged(e) {
        this.setState({ ...this.state, purpose: e.currentTarget.value })
    }

    descriptionChanged(text: String) {
        this.setState({
            ...this.state,
            clanData: {
                ...this.state.clanData,
                description: text,
                rawDescription: text,
            },
        })
    }

    getNormalizedDescription() {
        return this.state.clanData.rawDescription.trim().replace(/[ \t]{2,}/g, ' ')
    }

    updateSettings() {
        dwhExport.send('requests.change_requirements')
        const clanSettings = {
            languages: this.getSelectedLanguages(),
            purpose: this.state.purpose,
            isRecommendable: this.state.isRecommendable,
            isVoiceChatRequired: this.state.isVoiceChatRequired,
        }
        this.props.updateSettings(clanSettings, this.getNormalizedDescription())
    }

    renderIsRecommendableParameter() {
        return (
            <CheckboxWithLabel
                className={styles.isRecommendableCheckbox}
                labelText={t('Предлагать клан для вступления в Рекомендательной системе')}
                isChecked={this.state.isRecommendable}
                onChange={this.isRecommendableChanged} />
        )
    }

    renderIsVoiceChatRequired() {
        return (
            <CheckboxWithLabel
                labelText={t('Голосовая связь обязательна')}
                isChecked={this.state.isVoiceChatRequired}
                onChange={this.isVoiceChatRequiredChanged} />
        )
    }

    renderPurposeParameter() {
        return (
            <div className={styles.purposeParameter}>
                <div className={styles.purposeParameterGroup}>
                    <Radio
                        key="purpose_no_obligations"
                        name="purpose"
                        onChange={this.purposeChanged}
                        isChecked={this.state.purpose === PURPOSES.NO_OBLIGATIONS}
                        value={PURPOSES.NO_OBLIGATIONS} >
                        {t('Никаких обязательств')}
                    </Radio>
                </div>
                <div className={styles.purposeParameterGroup}>
                    <Radio
                        key="purpose_squad_battles"
                        name="purpose"
                        onChange={this.purposeChanged}
                        isChecked={this.state.purpose === PURPOSES.SQUAD_BATTLES}
                        value={PURPOSES.SQUAD_BATTLES} >
                        {t('Игра в отряде')}
                    </Radio>
                </div>
                <div className={styles.purposeParameterGroup}>
                    <Radio
                        key="purpose_clan_battles"
                        name="purpose"
                        onChange={this.purposeChanged}
                        isChecked={this.state.purpose === PURPOSES.CLAN_BATTLES}
                        value={PURPOSES.CLAN_BATTLES} >
                        {t('Клановые бои')}
                    </Radio>
                </div>
            </div>
        )
    }

    renderLanguagesParameter() {
        return Object.entries(this.state.languagesMap).map(
            ([languageCode]) => (
                <div key={languageCode} className={styles.language}>
                    <CheckboxWithLabel
                        labelText={get(LANGUAGES, languageCode, `[ ${languageCode} ]`)}
                        isChecked={get(this.state.languagesMap, languageCode, false)}
                        onChange={this.languageChanged(languageCode)} />
                </div>
            )
        )
    }

    render() {

        const languageNotSelectedMessage = this.state.isLanguageNotSelected
            ? (<Message type="error" style="inline">{t('Язык не выбран')}</Message>)
            : null

        const badDescriptionMessage = this.props.descriptionError !== ''
            ? (<Message type="error" style="inline">{this.props.descriptionError}</Message>)
            : null

        return (
            <DialogContainer>
                <DialogHeader>
                    {t('Требования клана')}
                </DialogHeader>
                <DialogBody>
                    <div className={styles.wrapper}>
                        <div className={styles.parameterGroup}>
                            <div className={styles.parameterGroupHeader}>
                                <span className={styles.parameterGroupTitle}>{t('Нам интересны:')}</span>
                                <span />
                            </div>
                            {this.renderPurposeParameter()}
                        </div>

                        <div className={styles.parameterGroup}>
                            <div className={styles.parameterGroupHeader}>
                                <span className={styles.parameterGroupTitle}>{t('Языки общения:')}</span>
                                <span>{languageNotSelectedMessage}</span>
                            </div>
                            {this.renderLanguagesParameter()}
                        </div>

                        <div className={styles.parameterGroup}>
                            <div className={styles.parameterGroupHeader}>
                                <span className={styles.parameterGroupTitle}>{t('Голосовая связь:')}</span>
                                <span />
                            </div>
                            {this.renderIsVoiceChatRequired()}
                        </div>

                        <div className={styles.parameterGroup}>
                            <div className={styles.parameterGroupHeader}>
                                <span className={styles.parameterGroupTitle}>{t('Описание клана:')}</span>
                                <span>{badDescriptionMessage}</span>
                            </div>
                            <Textarea
                                onChange={this.descriptionChanged}
                                value={this.state.clanData.rawDescription ? unescape(this.state.clanData.rawDescription) : ''}
                                width="100%"
                                height="130px"
                                maxLength={500}
                                isCounted />
                            <Terms className={styles.terms} />
                        </div>
                    </div>

                    <Processing isFetching={this.props.isFetching} label="" />
                </DialogBody>
                <DialogFooter>
                    {this.renderIsRecommendableParameter()}
                    <ButtonGroup>
                        <Button
                            isJustified
                            isDisabled={this.state.isLanguageNotSelected}
                            onClick={this.updateSettings}>
                            {t('Сохранить')}
                        </Button>
                        <Button isJustified onClick={this.props.hideDialog}>{t('Закрыть')}</Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>
        )
    }
}

ClanSettingsDialog.defaultProps = {
    isFetching: false,
    descriptionError: '',
    clanSettings: {
        languages: [],
        purpose: PURPOSES.NO_OBLIGATIONS,
        isRecommendable: true,
        isVoiceChatRequired: false,
    },
    clanData: {
        tag: '',
        name: '',
        color: '',
        description: '',
        rawDescription: '',
        id: 0,
    },
    description: '',
    hideDialog: () => { },
    updateSettings: (clanSettings: ClanRecommendationsSettings) => { },
    sendDescription: (description: String) => { },
    loadSettings: () => { },
}

export default ClanSettingsDialog